import React from "react";
import { Form, Input, Select, Button, Row, Col } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";

const { Option } = Select;

/**
 * 飞机过滤器组件
 * @param {Object} props
 * @param {Function} props.onSearch - 搜索回调函数
 * @param {Function} props.onReset - 重置回调函数
 */
const AircraftFilter = ({ onSearch, onReset }) => {
    const [form] = Form.useForm();

    // 重置表单
    const handleReset = () => {
        form.resetFields();
        onReset();
    };

    // 提交表单
    const handleFinish = (values) => {
        onSearch(values);
    };

    return (
        <Form form={form} layout="horizontal" onFinish={handleFinish} className="filter-form" labelAlign="right">
            <Row gutter={24}>
                <Col span={5}>
                    <Form.Item label="注册号" name="registration">
                        <Input placeholder="请输入注册号" allowClear />
                    </Form.Item>
                </Col>
                <Col span={5}>
                    <Form.Item label="机型" name="aircraft_type">
                        <Input placeholder="请输入机型" allowClear />
                    </Form.Item>
                </Col>
                <Col span={5}>
                    <Form.Item label="航班号偏移量" name="flight_number_offset">
                        <Input placeholder="请输入航班号偏移量" allowClear />
                    </Form.Item>
                </Col>
                <Col span={5}>
                    <Form.Item label="状态" name="status">
                        <Select placeholder="请选择状态" allowClear>
                            <Option value="ACTIVE">启用</Option>
                            <Option value="INACTIVE">停用</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col span={4} style={{ textAlign: "right" }}>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" icon={<SearchOutlined />} style={{ marginRight: 8 }}>
                            搜索
                        </Button>
                        <Button icon={<ReloadOutlined />} onClick={handleReset} style={{ marginRight: 8 }}>
                            重置
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default AircraftFilter;
